export default {"src":"/_next/static/media/ticket-icon.75f91d85.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};